import clsx from 'clsx';
import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
} from 'reactstrap';
import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';

import Icon from '../Icon';
import styles from './styles.module.scss';

const Textbox = ({
  autoComplete = 'off',
  autoFocus = false,
  className = '',
  'data-testid': dataTestid,
  error,
  icon,
  id,
  innerRef,
  feedback = 'Required',
  label = '',
  maxLength,
  max,
  min,
  name,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  placeholder = '',
  step,
  type = 'text',
  suffix,
  value,
}) => {
  const [state, setState] = useState('off');
  useEffect(() => {
    if (error) {
      setState('error');
    }
  }, [error]);

  const handleChange = (e) => {
    setState(error ? 'error' : 'focus');
    onChange(e);
  };

  const handleBlur = () => {
    setState(error ? 'error' : 'off');
    onBlur();
  };

  const handleFocus = () => {
    setState(error ? 'error' : 'focus');
    onFocus();
  };

  return (
    <FormGroup className={clsx('mb-1', className)}>
      <Label for={id} className="d-flex align-items-center text-sm gray700">
        {label}
      </Label>
      <InputGroup
        className={`${styles['textbox-input-group']} ${
          styles[`prepend-${state}`]
        }`}
      >
        {icon && (
          <InputGroupAddon addonType="prepend">
            <InputGroupText className="text-dark-gray border-0">
              <Icon name={icon} variant="regular" />
            </InputGroupText>
          </InputGroupAddon>
        )}
        <Input
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          className={clsx('border-0', 'fs-16', icon && 'pl-0')}
          data-testid={dataTestid}
          id={id}
          innerRef={innerRef}
          invalid={error ? true : false}
          maxLength={maxLength}
          max={max}
          min={min}
          name={name}
          onChange={(e) => handleChange(e)}
          onBlur={() => handleBlur()}
          onFocus={() => handleFocus()}
          placeholder={placeholder}
          step={step}
          type={type}
          value={value}
        />
        {suffix && (
          <div className="input-group-append">
            <span className="input-group-text bg-dark text-white fs-16 rounded-right border-dark">
              {suffix}
            </span>
          </div>
        )}
      </InputGroup>
      {error && (
        <Label className={styles['validation-fail']}>
          <Icon name="exclamation-triangle" variant="solid" />
          <span className="ml-2">{feedback}</span>
        </Label>
      )}
    </FormGroup>
  );
};

Textbox.propTypes = {
  autoComplete: propTypes.string,
  autoFocus: propTypes.bool,
  'data-testid': propTypes.string,
  error: propTypes.bool,
  icon: propTypes.string,
  id: propTypes.string,
  innerRef: propTypes.func,
  feedback: propTypes.string,
  label: propTypes.string,
  maxLength: propTypes.number,
  max: propTypes.string,
  min: propTypes.string,
  name: propTypes.string,
  onChange: propTypes.func,
  onBlur: propTypes.func,
  onFocus: propTypes.func,
  placeholder: propTypes.string,
  step: propTypes.string,
  className: propTypes.string,
  type: propTypes.string,
  value: propTypes.string,
  suffix: propTypes.string,
};

export default Textbox;
